const BRAZIL_AREA_CODE_LENGTH = 2;
const BRAZIL_PREFIX_PHONE_LENGTH = 5;
const MOBILE_PHONE_REGEX = /\(\d{2}\)\s\d{5}-\d{4}/;

export function formatPhoneInputAsTheUserTypes(inputPhone: string) {
  const matchedPhone = inputPhone.replace(/-| |\(|\)/g, '').match(/(\d{1,11})/g);
  const phoneValue = matchedPhone ? matchedPhone[0] : '';

  const phoneValueLength = phoneValue.length;
  let formattedPhoneValue: string;

  if (phoneValueLength <= BRAZIL_AREA_CODE_LENGTH) {
    formattedPhoneValue = phoneValue.replace(/(\d{1,2})/g, '($1');
  } else if (phoneValueLength <= BRAZIL_AREA_CODE_LENGTH + BRAZIL_PREFIX_PHONE_LENGTH) {
    formattedPhoneValue = phoneValue.replace(/(\d{1,2})(\d{1,5})/g, '($1) $2');
  } else {
    formattedPhoneValue = phoneValue.replace(/(\d{1,2})(\d{1,5})(\d{1,4})/g, '($1) $2-$3');
  }

  return formattedPhoneValue;
}

export function isMobilePhoneValid(mobilePhone: string) {
  return MOBILE_PHONE_REGEX.test(mobilePhone);
}
